// extracted by mini-css-extract-plugin
export default {"timetables":"WorkshopTimeTable_timetables__+VwwQ"};